<template>
  <div class="meter-read">
    <div class="meter-read__title">
      {{ title }}
    </div>
    <div class="meter-read__value">
      <Wattage :value="animatedValue" :type="valueType" />
    </div>
    <div class="meter-read__arrows">
      <ConsumptionArrow
        type="positive"
        :angle="communityArrowAngle"
        :disabled="communityArrowDisabled"
      />
      <ConsumptionArrow
        :type="supplierArrowType"
        :angle="supplierArrowAngle"
        :disabled="supplierArrowDisabled"
      />
    </div>
  </div>
</template>

<script>
  import ConsumptionArrow from '@/components/icons/ConsumptionArrow'
  import Wattage from '@/components/Wattage'
  import TweenLite from 'gsap'

  export default {
    name: 'meter-read',
    components: {
      ConsumptionArrow,
      Wattage,
    },
    data() {
      return {
        animatedValue: 0,
      }
    },
    mounted() {
      this.animatedValue = this.$store.getters.currentRead
    },
    computed: {
      title: function () {
        if (this.$store.getters.currentReadIsConsumption) {
          return this.str('home.consumption')
        } else {
          return this.str('home.production')
        }
      },
      value: function () {
        return this.$store.getters.currentRead
      },
      valueType: function () {
        const read = this.$store.getters.currentReads
        if (read.toCommunity > 0 || read.toSupplier > 0) {
          return 'positive'
        } else {
          return 'negative'
        }
      },
      communityArrowAngle: function () {
        const read = this.$store.getters.currentReads
        if (read.toCommunity) {
          return 180
        } else {
          return 0
        }
      },
      communityArrowDisabled: function () {
        const read = this.$store.getters.currentReads
        return read.toCommunity === 0 && read.fromCommunity === 0
      },
      supplierArrowAngle: function () {
        const read = this.$store.getters.currentReads
        if (read.toSupplier) {
          return 180
        } else {
          return 0
        }
      },
      supplierArrowDisabled: function () {
        const read = this.$store.getters.currentReads
        return read.toSupplier === 0 && read.fromSupplier === 0
      },
      supplierArrowType: function () {
        const read = this.$store.getters.currentReads
        return read.toSupplier > 0 ? 'positive' : 'negative'
      },
    },
    watch: {
      value: function (newValue) {
        TweenLite.to(this.$data, this.$store.getters.wattageTweenDuration, {
          animatedValue: newValue,
        })
      },
    },
  }
</script>

<style lang="scss">
  .meter-read {
    text-align: center;
    transition: $transition-base;

    @media (min-width: 360px) {
      //margin-top: 1vh;
    }

    @media (min-height: 600px) {
      margin-top: 2vh;

      @media (min-width: 360px) {
        margin-top: 1vh;
      }
    }

    @media (min-height: 600px) {
      @media (min-width: 360px) {
        margin-bottom: 2vh;
      }
    }

    @media (min-height: 700px) {
      margin-bottom: 0;
    }

    @media (min-height: 800px) {
      margin-top: 2vh;
      margin-bottom: 2vh;
    }

    &__title {
      line-height: $line-height-sm;
      font-size: $font-size-sm;

      @media (min-width: $bp-xs) {
        font-size: $font-size-base;
      }
    }

    &__value {
      line-height: $line-height-sm;
      font-size: $wattage-font-size-min;
    }
  }
</style>
